export type Organization = {
  org_id?: string;
  name: string;
  type?: string;
  primary_contact_name?: string;
  primary_contact_email?: string;
  secondary_contact_name?: string;
  secondary_contact_email?: string;
  logo_url?: string;
};

export enum ORG_TYPE {
  EDUCATIONAL = "educational",
  CLINIC = "clinic",
}

export const ORG_TYPES = [
  { value: ORG_TYPE.EDUCATIONAL, label: "Educational" },
  { value: ORG_TYPE.CLINIC, label: "Clinic" },
];
